import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-image-gallery',
    templateUrl: './modal-image-gallery.component.html',
    styleUrls: ['./modal-image-gallery.component.scss'],
    standalone: false
})
export class ModalImageGalleryComponent implements OnInit {

  public data: any = {};

  public title: string = '';
  public content: string = '';

  public imageData = {
    url: '',
    gallery: <any> []
  };


  /**
   * Constructor
   *
   * @param activeModal
   */
  constructor(public activeModal: NgbActiveModal) {



  }

  ngOnInit(): void {

    if (this.data.hasOwnProperty('url')) {
      this.imageData.url = this.data.url;
    }

    if (this.data.hasOwnProperty('gallery')) {
      this.imageData.gallery = this.data.gallery;
    }

  }

}
